import { Injectable } from "@angular/core";
import { HttpService } from "src/app/session/services/http.service";
import { environment } from "src/environments/environment";
import { PendingDuplicateSection } from "../model/pending-duplicate-section";
import { PendingRenameSection } from "../model/pending-rename-section";
import { PendingDeleteSection } from "../model/pending-delete-section";
import { PendingDuplicateField } from "../model/pending-duplicate-field";
import { PendingRenameField } from "../model/pending-rename-field";
import { PendingDeleteField } from "../model/pending-delete-field";
import { PendingDuplicateNaturalSection } from "../model/pending-duplicate-natural-section";
import { HttpHeaders } from "@angular/common/http";
import { PendingDuplicateNaturalField } from "../model/pending-duplicate-natural-field";
import { PendingReorderSections } from "../model/pending-reorder-fields";

@Injectable({
  providedIn: "root",
})
export class FormDefinitionService {
  constructor(private httpService: HttpService) {}

  async duplicateNaturalSection(
    sectionToBeDuplicated: PendingDuplicateNaturalSection,
  ) {
    let itemParam = sectionToBeDuplicated.itemId
      ? `?itemId=${sectionToBeDuplicated.itemId}`
      : "?itemId=";
    let url = `${environment.webApiUrl}/api/PendingChanges/${sectionToBeDuplicated.inspectionId}/DuplicateSection/${sectionToBeDuplicated.duplicatedSection.id}${itemParam}`;
    await this.httpService
      .put(url, sectionToBeDuplicated, { withCredentials: true })
      .toPromise();
  }

  async reorderSections(sectionsToBeReReordered: PendingReorderSections) {
    await this.httpService
      .put(
        `${environment.webApiUrl}/api/PendingChanges/ReorderSections`,
        sectionsToBeReReordered,
        { withCredentials: true },
      )
      .toPromise();
  }

  async renameSection(sectionToBeRenamed: PendingRenameSection) {
    await this.httpService
      .put(
        `${environment.webApiUrl}/api/PendingChanges/RenameSection`,
        sectionToBeRenamed,
        { withCredentials: true },
      )
      .toPromise();
  }

  async deleteSection(sectionToBeDeleted: PendingDeleteSection) {
    let itemParam = sectionToBeDeleted.itemId
      ? `?itemId=${sectionToBeDeleted.itemId}`
      : "";
    let url = `${environment.webApiUrl}/api/PendingChanges/${sectionToBeDeleted.inspectionId}/deleteSection/${sectionToBeDeleted.sectionId}${itemParam}`;
    await this.httpService
      .put(url, sectionToBeDeleted, { withCredentials: true })
      .toPromise();
  }

  async duplicateNaturalField(
    fieldToBeDuplicated: PendingDuplicateNaturalField,
  ) {
    await this.httpService
      .put(
        `${environment.webApiUrl}/api/PendingChanges/DuplicateField`,
        fieldToBeDuplicated,
        { withCredentials: true },
      )
      .toPromise();
  }

  async renameField(fieldToBeRenamed: PendingRenameField) {
    await this.httpService
      .put(
        `${environment.webApiUrl}/api/PendingChanges/RenameField`,
        fieldToBeRenamed,
        { withCredentials: true },
      )
      .toPromise();
  }

  async deleteField(fieldToBeDeleted: PendingDeleteField) {
    await this.httpService
      .put(
        `${environment.webApiUrl}/api/PendingChanges/DeleteField`,
        fieldToBeDeleted,
        { withCredentials: true },
      )
      .toPromise();
  }
}
